import { Component, OnDestroy, OnInit } from '@angular/core'
import { KeyingAuthService } from '../../services/keying.auth.service'
import { AppRoutingConfig } from '../../configuration/app.routing.config'
import { Subject } from 'rxjs'
import { NavService } from '../../services/nav.service'
import { takeUntil } from 'rxjs/operators'
import { Loading, LoadingService } from '../../services/loading.service'
import { User } from '@overtur-monorepo/keying-user'
import { KeyingStructureService } from '../../services/keying.structure.service'
import { ThirdPartyNoticeComponent } from '@overtur-monorepo/phx-angular-material'
import { MatDialog } from '@angular/material/dialog'

@Component({
    selector: 'app-mk-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  loading: Loading

  title = 'Keying'
  user: User

  profileActions = [{ name: AppRoutingConfig.logoutUrl, icon: 'logout', id: 0 }]

  helpActions = [
    { name: AppRoutingConfig.supportUrl, icon: 'user', id: 0 },
    { name: 'Third party notice', icon: 'info', id: 1 },
  ]

  constructor(
    private navService: NavService,
    private keyingAuthService: KeyingAuthService,
    private loadingService: LoadingService,
    private keyingStructureService: KeyingStructureService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.navService.setProfileActions(this.profileActions)
    this.navService.setHelpActions(this.helpActions)

    this.loadingService.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      this.loading = loading
    })

    this.keyingAuthService.keyingUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user) {
        this.user = user
        this.keyingAuthService.getUsers()
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  profileAction(action) {
    switch (action.id) {
      case 0:
        this.keyingAuthService.logout()
        break
      default:
        break
    }
  }

  helpAction(action) {
    switch (action.id) {
      case 1:
        this.openLicenceFile()
        break
      default:
        break
    }
  }

  openLicenceFile() {
    this.dialog.open(ThirdPartyNoticeComponent)
  }
}
